<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            Groups
            <add-button link="/main/groups/create"></add-button>
            <upload-button link="/main/groups/upload"></upload-button>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Groups</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Name</th>
                        <th>Logo Path</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Address1</th>
                        <th>Address2</th>
                        <th>Country</th>
                        <th>State</th>
                        <th>City</th>
                        <th>Pincode</th>
                        <th>GstNo</th>
                        <th>PanNo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="11"></loading-table>
                      <router-link 
                        v-for="(group, at) in groups"
                        :key="`group${at}`"
                        :to="`/main/groups/${group.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ group.name || '' }}</td>
                        <td><img v-if="group.logo_path" :src="mediaUrl + group.logo_path" style="width: 70px; height: 70px;" /></td>
                        <td>{{ group.email }}</td>
                        <td>{{ group.phone }}</td>
                        <td>{{ group.address_1 }}</td>
                        <td>{{ group.address_2 }}</td>
                        <td>{{ group.country ? group.country.code : '' }}</td>
                        <td>{{ group.state ? group.state.code : '' }}</td>
                        <td>{{ group.city }}</td>
                        <td>{{ group.pincode }}</td>
                        <td>{{ group.gstin_no }}</td> 
                        <td>{{ group.pan_no }}</td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'groups',
  data () {
    return {
      groups: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true
      let groups = await axios.get(`/groups?page=${page}&rowsPerPage=${this.rowsPerPage}&search=all`)
      this.groups = groups.data.data
      this.count = groups.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    }
  }
}
</script>